import Header from "./Header";
import Footer from "./Footer";
import MobileCallBar from "./MobileCallBar";
import CookieBanner from "./CookieBanner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 pt-24 md:pt-28">{children}</main>
      <Footer />
      <MobileCallBar />
      <CookieBanner />
    </div>
  );
}
